module.exports = __webpack_public_path__ + "img/pic-5-1.33c0a878.png";